<template>
	<div class="login-container">
		<van-form @submit="onSubmit" :show-error="false" label-width="0">
			<van-field
				readonly
				clickable
				v-model="idName"
				placeholder="请选择证件照类型"
				:rules="[{ required: true, message: '必选', trigger: 'onChange' }]"
				@click="showPicker = true" />
			<van-field
				v-model="form.idNum"
				clearable
				placeholder="请输入证件号码"
				:rules="[{ required: true, message: '必填', trigger: 'onChange' }]" />
			<van-field
				v-if="form.userLoginType == 1"
				v-model="form.password"
				:type="passwordType"
				key="p"
				name="password"
				clearable
				placeholder="请输入密码"
				:rules="[{ required: true, message: '必填', trigger: 'onChange' }]">
				<van-icon slot="right-icon" :name="passwordType == 'password' ? 'closed-eye' : 'eye-o'" @click="showPassword" />
			</van-field>
			<van-field
				v-if="form.userLoginType == 2"
				v-model="form.userName"
				key="n"
				clearable
				placeholder="请输入姓名/名称"
				:rules="[{ required: true, message: '必填', trigger: 'onChange' }]" />
			<van-field>
				<template #input>
					<van-field
						v-model="form.random"
						class="nobd"
						maxlength="5"
						clearable
						placeholder="请输入验证码"
						:rules="[{ required: true, message: '必填', trigger: 'onChange' }]" />
					<van-image @click="getValidCode" width="140" height="35" :src="valid_code_url" />
				</template>
			</van-field>
			<div class="login-btn">
				<van-button block type="info" native-type="submit">登录</van-button>
			</div>
			<div class="login-btn">
				<van-button block @click="register">注册</van-button>
			</div>
			<div class="login-btn">
				<van-button block @click="anonymous">无记名交费</van-button>
			</div>
		</van-form>
		<van-popup v-model="showPicker" position="bottom">
			<van-picker show-toolbar value-key="name" :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
		</van-popup>
	</div>
</template>

<script>
import log from 'utils/log'
import apiLoginPage from '@/api/login-page'
import utils from '@/utils/util'
import { saveToken } from '@/utils/cache'
import rsaKeyUtil from '@/utils/RsaKeyUtil'
import { md5 } from '@/utils/md5'
import store from '@/store'
export default {
	name: 'Login',
	data() {
		return {
			showPicker: false,
			valid_code_url: '',
			idName: '',
			columns: [],
			form: {
				idType: '',
				idNum: '',
				password: '',
				userName: '',
				random: '',
				userLoginType: 0
			},
			passwordType: 'password',
			isWx: utils.isWeChatBrowser()
		}
	},
	created() {
		this.getValidCode()
		this.getCardType()
	},
	methods: {
		anonymous() {
			this.$router.replace({ name: 'anonymous-pay' })
		},
		register() {
			console.log(this.wConfig)
			this.$router.replace({ name: 'register' })
		},
		onConfirm(cardType) {
			this.idName = cardType.name
			this.form.idType = cardType.id
			if (cardType.code == 'IDCard') {
				this.form.userLoginType = cardType.extType
			} else {
				this.form.userLoginType = 1
			}
			this.showPicker = false
		},
		showPassword() {
			this.passwordType === '' ? (this.passwordType = 'password') : (this.passwordType = '')
		},
		getValidCode() {
			let d = new Date()
			let url = process.env.VUE_APP_BASE_API
			url = url.startsWith('http') ? url : window.location.protocol + '//' + url
			let url2 = url + '/shiro/get/random/image?' + d.getTime()
			this.valid_code_url = url2
		},
		getCardType() {
			apiLoginPage.loginCardType().then(res => {
				this.columns = res.data
			})
		},
		reset() {
			this.idName = ''
			this.form = {
				idType: '',
				idNum: '',
				password: '',
				userName: '',
				random: ''
			}
		},
		onSubmit(values) {
			let { idType, password, idNum, random, userName, userLoginType } = this.form
			let param = {
				idType: this.form.idType,
				password: rsaKeyUtil.encrypt(md5(password)),
				idNum: rsaKeyUtil.encrypt(idNum),
				random: random
			}
			apiLoginPage
				.login(param)
				.then(res => {
					saveToken(res.data)
					this.$store.dispatch('mars/user/getUserInfo')
					this.$router.replace({ name: 'home' })
				})
				.catch(() => {
					this.getValidCode()
				})
		}
	}
}
</script>

<style lang="scss">
.nobd.van-field {
	padding-left: 0;
	&::after {
		border: none;
	}
}
</style>
